import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@material-ui/core';
import React, { FC, useState } from 'react';
import { createUseStyles } from '../../../../../../../theming';
import EmployeeSelect from './EmployeeSelect';

interface Props {
  open: boolean;
  previousEmployeeId?: string;
  onClose: () => void;
  onValidate: (employeeId: string) => void;
}

const useStyles = createUseStyles({
  formField: {
    marginTop: '15px !important',
  },
  contentText: {
    marginBottom: '16px !important',
  },
  error: {
    color: '#f44336',
  },
});

const UpdateEmployeeModal: FC<Props> = ({ previousEmployeeId, open, onValidate, onClose }) => {
  const [employeeId, setEmployeeId] = useState(previousEmployeeId);
  const [, setFormError] = useState<string | undefined>();
  const [loading, setLoading] = useState(false);

  const classes = useStyles();

  const handleValidate = async () => {
    try {
      if (!employeeId) {
        throw new Error('Vous devez selectionner un employé');
      }

      setLoading(true);

      await onValidate(employeeId);

      setLoading(false);
      setFormError(undefined);
      onClose();
    } catch (e) {
      setLoading(false);
      setFormError(e.message);
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Choisir un employé</DialogTitle>

      <DialogContent>
        <DialogContentText className={classes.contentText}>Vous allez modifier l'employé en charge.</DialogContentText>

        <EmployeeSelect value={employeeId} onChange={(value) => setEmployeeId(value)} />
      </DialogContent>

      <DialogActions>
        <Button type='button' onClick={onClose} color='primary'>
          Annuler
        </Button>

        <Button type='submit' onClick={handleValidate} color='primary'>
          {loading && <CircularProgress color='primary' size={15} />} Valider
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UpdateEmployeeModal;
